// extracted by mini-css-extract-plugin
export var locationCard = "_hv-0";